/* eslint-disable react/jsx-wrap-multilines */
import { Button } from '@rentspree/component-2023.components.atoms.button'
import PropTypes from 'prop-types'
import { useContext } from 'react'

import { useModal } from '@hooks'
import { ListingIdContext } from 'context/listingIdContext'
import { useTracker } from 'store/@hooks/use-tracker'
import { LISTING_PUBLIC_PAGE } from 'tracker/events'

import { BUTTON_TEXT } from './const'
import { ScheduleTourWizard } from './schedule-tour-wizard'

interface ScheduleTourProps {
  isPreview?: boolean
}

export const ScheduleTour: React.FC<ScheduleTourProps> = ({ isPreview = false }) => {
  const listingId = useContext(ListingIdContext)
  const track = useTracker()
  const modalOptions = {
    preventScroll: false,
    closeOnOverlayClick: false,
    customStyled: {},
  }
  const [Modal, openModal, closeModal] = useModal('__next', modalOptions)
  const handleOnClick = () => {
    openModal()
    track(LISTING_PUBLIC_PAGE.CLICK_REQUEST_TOUR, {
      listing_id: listingId,
    })
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        id="request-tour"
        disabled={isPreview}
        onClick={handleOnClick}
      >
        {BUTTON_TEXT}
      </Button>
      <Modal>
        <ScheduleTourWizard handleCloseModal={closeModal} data-testid="schedule-modal" />
      </Modal>
    </>
  )
}

ScheduleTour.defaultProps = {
  isPreview: false,
}

ScheduleTour.propTypes = {
  isPreview: PropTypes.bool,
}
